import { useAuthStore } from '@/stores/AuthStore';
import { Navigate } from 'react-router-dom';
import { ReactNode, useMemo } from 'react';

interface PublicRouteProps {
  noRedirect?: boolean;
  children: ReactNode;
}

const PublicRoute = ({ children, noRedirect }: PublicRouteProps) => {
  const { getUser, getToken } = useAuthStore();

  const tokens = useMemo(() => getToken(), []);
  const user = useMemo(() => getUser(), []);

  if (user && tokens && !noRedirect) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
};

export default PublicRoute;
